import { useState } from 'react';

import Link from 'next/link';
import Image from 'next/image';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import SmsTracking from '@/components/ui/icons/SmsTracking';
import ExportArrow from '@/components/ui/icons/ExportArrow';

// utilities
import { getImagePath } from '@/utils/images';

const Footer = ({ footer }) => {
  return (
    <div data-variant="dark" className="relative z-2 -mt-[32px] rounded-t-[32px] bg-black text-white">
      <div className="mx-auto w-[90vw] pt-32 pb-10 xl:w-(--container-width)">
        {footer?.logo && (
          <Link href="/">
            <Image
              src={getImagePath(footer.logo)}
              width={footer.logo.width * 1.35}
              height={footer.logo.height * 1.35}
              alt={footer.logo.alternativeText}
              priority={false}
            />
          </Link>
        )}
        <div className="mt-16 mb-20 flex flex-wrap justify-between gap-x-6 gap-y-12">
          <div className="txt-md flex flex-1 flex-wrap gap-x-16 gap-y-8">
            {(footer?.columns || []).map((column) => (
              <div key={column.id} className="flex min-w-[190px] flex-col gap-4">
                {column.linksBlockContent.map((link) => (
                  <div key={link.id} className="text-white-75 flex items-center gap-2">
                    <Link
                      href={link.link}
                      target={link.newWindow ? '_blank' : '_self'}
                      rel={link.newWindow ? 'noreferrer noopener' : undefined}
                      className={`text-white-75 underline-offset-3 hover:text-white hover:underline`}
                    >
                      {link.label}
                    </Link>

                    {link.newWindow && <ExportArrow width={12} height={12} />}
                  </div>
                ))}
              </div>
            ))}
          </div>
          {footer.signup && <SignUp signup={footer.signup} />}
        </div>

        <div className="txt-sm mb-12 text-left whitespace-pre-wrap xl:mb-3 xl:text-center xl:whitespace-normal">
          {footer.address}
        </div>

        <div className="txt-sm flex flex-wrap items-center justify-center gap-6">
          <span className="basis-full xl:basis-auto">ⓒ Leadhub {new Date().getFullYear()}</span>
          {(footer?.bottomLinks || []).map((link) => (
            <span key={link.id} className="basis-full xl:basis-auto">
              <Link
                href={link.link}
                target={link.newWindow ? '_blank' : '_self'}
                rel={link.newWindow ? 'noreferrer noopener' : undefined}
                className="hover:underline hover:underline-offset-4"
              >
                {link.label}
              </Link>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Footer;

const SignUp = ({ signup }) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [email, setEmail] = useState('');

  const onSubmit = (e) => {
    e.preventDefault();

    setIsSubmitted(true);

    if (email && window.lhi) {
      window.lhi('identify', {
        email: email,
        subscribe: ['newsletters']
      });
    }
  };

  return (
    <div className="max-w-[400px]">
      <div className="txt-xl mb-6">{signup.label}</div>

      {isSubmitted ? (
        <div className="flex w-full gap-2">
          <SmsTracking /> {signup.submitText}
        </div>
      ) : (
        <form onSubmit={onSubmit} className="flex w-full flex-wrap gap-2">
          <Input
            type="email"
            className="bg-white-15 min-w-[265px] flex-1 border-transparent px-6"
            placeholder={signup.placeholder}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required={true}
          />
          <Button size={signup.button.size} variant={signup.button.variant} className="basis-full xl:basis-auto">
            {signup.button.label}
          </Button>
        </form>
      )}
    </div>
  );
};
